// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3V-lz","tab":"ProcedureTabs_tab__35n9a"};